(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["koshnika-description-inline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('k-desc-inline')) {
    customElements.define(
      'k-desc-inline',
      class extends HTMLElement {
        connectedCallback() {
          this.body = this.querySelector('.k-desc__body');
          this.toggle = this.querySelector('.k-desc__toggle');
          if (!this.body || !this.toggle) return;

          this.onClick = this.onClick.bind(this);
          this.toggle.addEventListener('click', this.onClick);

          // Measure before clamping; only clamp when it saves real space.
          requestAnimationFrame(() => {
            const lh = parseFloat(getComputedStyle(this.body).lineHeight) || 24;
            const lines = parseFloat(getComputedStyle(this).getPropertyValue('--k-desc-lines')) || 4;
            if (this.body.scrollHeight > lh * (lines + 1.5)) {
              this.classList.add('is-clamped');
              this.toggle.hidden = false;
            }
          });
        }

        disconnectedCallback() {
          if (this.toggle) this.toggle.removeEventListener('click', this.onClick);
        }

        onClick() {
          const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
          this.classList.toggle('is-clamped', expanded);
          this.toggle.setAttribute('aria-expanded', String(!expanded));
          this.toggle.textContent = expanded ? this.toggle.dataset.more : this.toggle.dataset.less;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
